import { UseFormReturnType } from '@mantine/form';
import { UpsertEntityInput } from '../data-capture/merge-review/useUpsertEntities';
import { DynamicUiData, FieldWithValue, FormValuesType } from '../UI/dynamicUI/types';

const isObject = (value: unknown) =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const prepFormValuesForUpsert = (
  formValues: FormValuesType,
  uiData: DynamicUiData,
  form: UseFormReturnType<FormValuesType>,
  preventTouchedFieldsFilter = false,
) => {
  return Object.keys(formValues)
    .filter(
      entityType =>
        preventTouchedFieldsFilter || (form.isDirty(entityType) && !!uiData?.entities[entityType]),
    )
    .map((entityType): UpsertEntityInput | UpsertEntityInput[] => {
      const entityTypeValues = formValues[entityType];
      if (
        isObject(entityTypeValues) &&
        formValues[entityType] &&
        !Array.isArray(entityTypeValues)
      ) {
        return {
          entityFieldsMetadata: uiData.ui.entitiesMetadata[entityType],
          entityType: entityType,
          values: formValues[entityType],
        };
      }

      if (Array.isArray(entityTypeValues)) {
        return {
          entityFieldsMetadata: uiData.ui.entitiesMetadata[entityType],
          entityType: entityType,
          values: entityTypeValues.map(
            (_, index) => (formValues[entityType] as FieldWithValue[])[index],
          ),
        };
      }

      throw Error('Unexpected data format during form submission');
    })
    .flatMap(e => e);
};
